import { dispatchMicrofrontendEvent, type HeaderVisibilityEventDetail } from '@experience/core-hostapp-share-lib';
import { ref, onMounted, onBeforeUnmount, inject } from 'vue';

export const useInverseHeader = () => {
  const isSearchVisible = ref(false);
  let searchObserver: IntersectionObserver | null = null;

  // Получаем shadowRoot из provide
  const shadowRoot = inject<ShadowRoot | null>('shadowRoot', null);

  const changeHeader = (detail: HeaderVisibilityEventDetail) => {
    dispatchMicrofrontendEvent('microfrontend-header-visibility', detail);
  };

  const updateHeader = () => {
    const detail = {
      hideSearch: isSearchVisible.value,
      fixedHeader: !isSearchVisible.value,
      inverseHeader: isSearchVisible.value,
    };

    changeHeader(detail);
  };

  // Обсервер для отслеживания видимости элемента .search
  const initSearchObserver = () => {
    // Ищем элемент внутри Shadow DOM
    const root = shadowRoot || document;
    const searchElement = root.querySelector('.search');

    if (!searchElement) {
      return;
    }

    searchObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          isSearchVisible.value = entry.isIntersecting;
          updateHeader(); // Обновляем header при изменении видимости
        });
      },
      {
        root: null, // Отслеживаем относительно viewport
        threshold: 0.1, // Срабатывает когда хотя бы 10% элемента видно
      },
    );

    searchObserver.observe(searchElement);
  };

  const params = { inverseHeader: true, fixedHeader: true, hideSearch: true };

  changeHeader(params);

  onMounted(() => {
    initSearchObserver();
  });

  onBeforeUnmount(() => {
    if (searchObserver) {
      searchObserver.disconnect();
      searchObserver = null;
    }

    changeHeader({ inverseHeader: false, fixedHeader: false, hideSearch: false });
  });
};
